import { useLanguage } from '../contexts/LanguageContext';
import { Cookie, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function CookiesPage() {
  const { language } = useLanguage();
  const isPt = language === 'pt';

  return (
    <div data-testid="cookies-page" className="pt-20 min-h-screen bg-background-light">
      <section className="py-16 bg-white border-b border-slate-200">
        <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-4xl">
          <Link to="/">
            <Button variant="ghost" className="mb-6 text-primary-deep hover:text-accent-blue p-0">
              <ArrowLeft className="w-4 h-4 mr-2" />
              {isPt ? 'Voltar ao início' : 'Back to home'}
            </Button>
          </Link>
          
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-xl bg-primary-deep/10 flex items-center justify-center">
              <Cookie className="w-7 h-7 text-primary-deep" />
            </div>
            <div>
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-dark">
                {isPt ? 'Política de Cookies' : 'Cookie Policy'}
              </h1>
              <p className="text-slate-500 text-sm mt-1">
                {isPt ? 'Última atualização: Janeiro 2025' : 'Last updated: January 2025'}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-4xl">
          <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 md:p-12 space-y-10">

            <p className="text-slate-600 leading-relaxed">
              {isPt 
                ? 'Esta Política de Cookies explica como utilizamos cookies e tecnologias semelhantes no nosso website.'
                : 'This Cookie Policy explains how we use cookies and similar technologies on our website.'}
            </p>
            
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-dark mb-4">
                {isPt ? '1. O Que São Cookies?' : '1. What Are Cookies?'}
              </h2>
              <p className="text-slate-600 leading-relaxed">
                {isPt 
                  ? 'Cookies são pequenos ficheiros de texto armazenados no seu dispositivo quando visita um website. Permitem que o website memorize as suas preferências e melhore a sua experiência de navegação.'
                  : 'Cookies are small text files stored on your device when you visit a website. They allow the website to remember your preferences and improve your browsing experience.'}
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-dark mb-4">
                {isPt ? '2. Tipos de Cookies' : '2. Types of Cookies'}
              </h2>
              <p className="text-slate-600 leading-relaxed whitespace-pre-line">
                {isPt 
                  ? 'Cookies Essenciais: Necessários para o funcionamento do website.\n\nCookies Funcionais: Permitem funcionalidades melhoradas.\n\nCookies Analíticos: Ajudam-nos a compreender como utiliza o website.\n\nCookies de Terceiros: Provenientes de serviços integrados (Calendly, Google Maps).'
                  : 'Essential Cookies: Required for the website to function.\n\nFunctional Cookies: Enable enhanced features.\n\nAnalytical Cookies: Help us understand how you use the website.\n\nThird-Party Cookies: From integrated services (Calendly, Google Maps).'}
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-dark mb-4">
                {isPt ? '3. Base Legal' : '3. Legal Basis'}
              </h2>
              <p className="text-slate-600 leading-relaxed">
                {isPt 
                  ? 'O uso de cookies baseia-se no RGPD e na Lei n.º 41/2004. Cookies essenciais não requerem consentimento. Outros cookies requerem o seu consentimento prévio.'
                  : 'The use of cookies is based on the GDPR and Portuguese Law No. 41/2004. Essential cookies do not require consent. Other cookies require your prior consent.'}
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-dark mb-4">
                {isPt ? '4. Gerir Cookies' : '4. Managing Cookies'}
              </h2>
              <p className="text-slate-600 leading-relaxed">
                {isPt 
                  ? 'Pode gerir as suas preferências através do banner de cookies ou das definições do seu navegador.'
                  : 'You can manage your preferences through the cookie banner or your browser settings.'}
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-dark mb-4">
                {isPt ? '5. Os Seus Direitos' : '5. Your Rights'}
              </h2>
              <p className="text-slate-600 leading-relaxed">
                {isPt 
                  ? 'Tem direito a aceder, eliminar e opor-se aos dados recolhidos através de cookies. Contacte-nos: info@diogoh.pt | +351 911 739 498'
                  : 'You have the right to access, delete, and object to data collected through cookies. Contact us: info@diogoh.pt | +351 911 739 498'}
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-dark mb-4">
                {isPt ? '6. Reclamações' : '6. Complaints'}
              </h2>
              <p className="text-slate-600 leading-relaxed whitespace-pre-line">
                {isPt 
                  ? 'Pode apresentar reclamação junto da CNPD:\nAv. D. Carlos I, 134 - 1.º, 1200-651 Lisboa\nwww.cnpd.pt'
                  : 'You can lodge a complaint with the CNPD:\nAv. D. Carlos I, 134 - 1.º, 1200-651 Lisboa\nwww.cnpd.pt'}
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
